import { TextBox, DateBox, NumberBox, SelectBox, CheckBox, RadioGroup, Button, TextArea } from 'devextreme-react';
import React from 'react';
import { Localization } from "../common/Localization";
import Validator, { RequiredRule, CustomRule } from 'devextreme-react/validator';
import DynamicFromLookup from './DynamicFromLookup';
import { FormatPhoneNumber,convertToCustomPhoneFormat } from '../common/Utils';
import TransNumSetup from './TransNumSetup';
import { RecordTypes } from '../enum/Enum';
function Fields ( field, formFields, handleFieldChange, isHidden,editMode, formRefs, handleSelectionChange,handleFocusIn ){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const RecordType = urlParams.get('RecordType');
  const isProfile = RecordType === RecordTypes.Profile;
  const fieldRef = (el) => {
    if (el) {
      if(formRefs)
        formRefs.current[field.name] = el;
    }
  };
  /** Ref callback for field types that render one editor per option (checkboxGroup).
   *  A single shared fieldRef would let each option overwrite the previous one, so the
   *  group keeps an array under its field name, ordered like field.options. */
  const groupFieldRef = (index) => (el) => {
    if (el && formRefs) {
      if (!Array.isArray(formRefs.current[field.name])) {
        formRefs.current[field.name] = [];
      }
      formRefs.current[field.name][index] = el;
    }
  };
  let fieldName=field.localizedField?field.localizedField:field.name;
  function parsePhoneFormat(input) {
      if(!input || input==="" || input ===null || input === undefined){
        return input;
    }
    const result = {
        part1: '',
        part2: '',
        part3: '',
        part4: ''
    };

    const regex = /^([^()]*?)\(([^)]*?)\)([^,]*?)(?:,(.*))?$/;
    const match = input.match(regex);

    if (match) {
        result.part1 = match[1] || '';
        result.part2 = match[2] || '';
        result.part3 = match[3] || '';
        result.part4 = match[4] || '';
    }

    return `${result.part1}${result.part2.padStart(6, ' ')}${result.part3.padStart(10, ' ')}${result.part4.padStart(7, ' ')}`;
}
    switch (field.type) {
      case 'text':
        return (
          <TextBox
            style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
            ref={fieldRef}
            value={formFields[field.name]}
            onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
            label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
            labelMode='static'
            stylingMode='outlined'
            readOnly={field.readOnly ? true : false}
             
            maxLength={field.maxLength??Localization.maxLength(`${field.tableName}.${fieldName}`)}
          >
            {field.required && !isProfile && !isHidden && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
          </TextBox>
        );
      case 'phone':
        return (
          <TextBox
            style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
            ref={fieldRef}
            value={parsePhoneFormat(formFields[field.name])}
            mask='0000(000000)0000000000,0000000'
            maskInvalidMessage=""
            isValid={true}
            useMaskedValue={false}
            onValueChanged={(e) => handleFieldChange(field.name, convertToCustomPhoneFormat(e.value), e)}
            label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
            labelMode='static'
            stylingMode='outlined'
            readOnly={field.readOnly ? true : false}
             
            maxLength={Localization.maxLength(`${field.tableName}.${fieldName}`)}
          >
            {field.required && !isProfile && !isHidden && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
          </TextBox>
        );
        case 'textarea':
          return (
            <TextArea
             style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
              ref={fieldRef}
              value={formFields[field.name]}
              onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
              label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
              labelMode='static'
              stylingMode='outlined'
              readOnly={field.readOnly ? true : false}
            >
              {field.required && !isProfile && !isHidden && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
            </TextArea>
          );
      case 'date':
        return (
          <DateBox
           style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
            ref={fieldRef}
            value={formFields[field.name]}
            onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
            label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
            labelMode='static'
            stylingMode='outlined'
            readOnly={field.readOnly ? true : false}
            
          >
            {field.required && !isProfile && !isHidden &&  <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
          </DateBox>
        );
      case 'datetime':
        return (
          <DateBox
           style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
            ref={fieldRef}
            value={formFields[field.name]}
            onValueChanged={(e) => handleFieldChange(field.name,e.value, e)}
            label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
            labelMode='static'
            stylingMode='outlined'
            type="datetime"
            readOnly={field.readOnly ? true : false}
          >
            {field.required && !isProfile && !isHidden &&  <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
          </DateBox>
        );
      case 'time':
        return (
          <DateBox
            style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
            ref={fieldRef}
            value={formFields[field.name]}
            onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
            label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
            labelMode='static'
            stylingMode='outlined'
            type="time"
            readOnly={field.readOnly ? true : false}
          >
            {field.required && !isProfile && !isHidden &&  <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
          </DateBox>
        );
      case 'number':
        return (
          <NumberBox
          style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
           ref={fieldRef}
            value={formFields[field.name]}
            onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
            label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
            labelMode='static'
            stylingMode='outlined'
            format={field.format ? field.format : undefined}
            readOnly={field.readOnly ? true : false}
          >
            {field.required && !isProfile && !isHidden && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
          </NumberBox>
        );
      case 'select':
        const maxLength = field.maxLength
    ? field.maxLength
    : null;
        return (
          <SelectBox
          style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
          ref={fieldRef}
          name={field.name}
          value={formFields[field.name] || null}
          searchEnabled={field.searchEnabled !== undefined ? field.searchEnabled : true}
          searchMode="contains"
          onFocusIn={(e) => {
            if (handleFocusIn) {
              handleFocusIn(field.name, e);
            } 
          }}
          onValueChanged={(e) => {
            if (e.value || field.showClearButton == true) {
              handleFieldChange(field.name, e.value, e)}
            }
           }
          onSelectionChanged={(e) => handleSelectionChange != null && handleSelectionChange(field.name, e)}
          label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
          labelMode='static'
          stylingMode='outlined'
          readOnly={field.readOnly ? true : false}
          acceptCustomValue={field.acceptCustomValue ? true : false}
          onCustomItemCreating={(e) => {
            if (e.text && field.acceptCustomValue) {
                e.customItem = e.text;  
                handleFieldChange(field.name, e.text, null)}
            }
           }
           showClearButton={field.showClearButton ? true : false}
          >
         {field.required && !isProfile && !isHidden && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
         
        </SelectBox>
        );
     case 'checkbox':
        return (
              <CheckBox
                style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 , marginTop: '10px' }}
                ref={fieldRef}
                text={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
                value={formFields[field.name]}
                onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
                readOnly={field.readOnly ? true : false}
              >
                {field.required && !isProfile && !isHidden && (
                  <Validator>
                    <CustomRule
                      message={`${field.label} is required`}
                      validationCallback={() => formFields[field.name] === true}
                    />
                  </Validator>
                )}
              </CheckBox>
        );
      case 'checkboxGroup':
        return (
          <>
            <p><b>{field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))} </b></p>
            {field.options.map((option, index) => (
              <CheckBox
              style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
                ref={groupFieldRef(index)}
                key={option}
                text={option}
                value={Array.isArray(formFields[field.name]) && formFields[field.name].includes(option)}
                onValueChanged={(e) => handleFieldChange(
                  field.name,
                  e.value
                    ? [...(formFields[field.name] || []), option]
                    : (formFields[field.name] || []).filter(val => val !== option),
                  e
                )}
                readOnly={field.readOnly ? true : false}
              >
                {field.required && !isProfile && !isHidden && (
                  <Validator>
                    <CustomRule
                      message={`${field.label} requires at least one selection`}
                      validationCallback={() => Array.isArray(formFields[field.name]) && formFields[field.name].length > 0}
                    />
                  </Validator>
                )}
              </CheckBox>
            ))}
          </>
        );
      case 'radio': {
        // DevExtreme's RadioGroup accepts readOnly (inherited from Editor) but only applies the
        // dx-state-readonly class and blocks the keyboard - its _itemClickHandler sets the value
        // with no readOnly check, so a mouse click still edits a read-only field. pointerEvents
        // blocks the mouse; readOnly keeps the styling and aria-readonly correct.
        const items = field.options || [];
        const first = items[0];
        const itemIsObjectWithValue =
          first != null &&
          typeof first === 'object' &&
          !Array.isArray(first) &&
          Object.prototype.hasOwnProperty.call(first, 'value');
        return (
          <>
            <p><b>{field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))} </b></p>
            <RadioGroup
            style={{ pointerEvents: (editMode || field.readOnly) ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
              ref={fieldRef}
              items={items}
              {...(itemIsObjectWithValue ? { valueExpr: 'value', displayExpr: 'text' } : {})}
              value={formFields[field.name] ?? null}
              onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
              readOnly={field.readOnly ? true : false}
            >
              {field.required && !isProfile && !isHidden && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
            </RadioGroup>
          </>
        );
      }
        case 'lookup':
          if (!field.layout) {
            return (
              <SelectBox
              style={{ pointerEvents: editMode ? "none" : "auto", opacity: editMode ? 0.5 : 1 }}
              ref={fieldRef}
              name={field.name}
              value={formFields[field.name] || null}
              searchEnabled={true}
              searchMode="contains"
              onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
              onSelectionChanged={(e) => handleSelectionChange != null && handleSelectionChange(field.name, e)}
              label={field.ignoredblocalization? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label))}
              labelMode='static'
              stylingMode='outlined'
              readOnly={field.readOnly ? true : false}
              >
              {/* No RequiredRule here. This branch is the placeholder for a lookup whose layout has
                  not been attached - layout is stripped on save (FormField removeLayouts) and only
                  restored from defaultFormSchema on load - so it has no dataSource and can never be
                  filled in. It is also replaced by DynamicFromLookup as soon as the layout arrives,
                  and that component owns the field's RequiredRule; validating in both places leaves
                  a second rule registered for the same field. */}
              </SelectBox>
            );
          }
          return (
            <DynamicFromLookup
            fieldRef={fieldRef}
            name={field.name}
            required={field.required && !isProfile && !isHidden}
            field={field}
            formFields={formFields}
            layout={field.layout}
            onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
            onCustomItemCreatingComponent={field.layout.onCustomItemCreatingComponent}
            editMode={editMode}
            handleSelectionChange ={handleSelectionChange}
            />
          );
         case 'transNumSetup':
          return (
            <TransNumSetup 
            fieldRef={fieldRef}
            required={field.required && !isProfile && !isHidden}
            field={field}
            formFields={formFields}
            onValueChanged={(e) => handleFieldChange(field.name, e.value, e)}
            editMode={editMode}            
            />
          );
      default:
        return null;
    }
  }

export default Fields;
